import { render, staticRenderFns } from "./ClientMedicalProfile.vue?vue&type=template&id=39a19105&"
import script from "./ClientMedicalProfile.vue?vue&type=script&lang=js&"
export * from "./ClientMedicalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports